import styled from 'styled-components';
import tw from 'tailwind-styled-components';
const Wrapper = tw.div`
w-[100%]
lg:w-1/2 justify-center flex
`;

export default Wrapper;
